module.exports = __webpack_public_path__ + "img/about-back-one.fa61b65a.png";